import { useBasename } from 'history';
import { browserHistory } from 'react-router';

export const history = useBasename(() => browserHistory)({
  basename: import.meta.env.BASE_URL,
});

export const navigate = (path: string): void => {
  history.push(path);
};

export const replaceUrl = (path: string): void => {
  history.replace(path);
};

export const goBack = (): void => {
  history.goBack();
};
